<template>
	<div>
		<van-row class="bmTitle">
			<van-col span="24">
				<h2>发票管理</h2>
			</van-col>
		</van-row>
		<van-row class="bmForm">
			<van-col span="24">
				<van-notice-bar style="font-size: 16px;">
				  温馨提示：发票申请截止至{{fpxxEndTime}}，如有疑问请联系会议主办方。
				  <template #left-icon>
				    <van-icon name='info-o' size="20" style="margin-right: 10px;" />
				  </template>
				</van-notice-bar>
				<div v-if="invoicesList">
					<van-card v-for="item in invoicesList" :key="item.id" style="padding:15px 16px;">
						<template #title>
							<h2 style="text-align: justify; font-size: 16px;margin:0;">订单编号:{{item.number}}
							</h2>
						</template>
						<template #desc>
							<p style="font-size: 14px;">发票抬头：{{item.title}}</p>
							<p style="font-size: 14px;">发票收件人邮箱：{{item.email}}</p>
						</template>
						<template #price>
							<div style="margin-bottom:10px;">

								<van-tag style="font-weight: normal; float: right;margin-top: 3px;" type="danger" round
									plain>{{item.status == 0?'未申请':'已申请'}}</van-tag>
							</div>
						</template>
						<template #footer>
							<van-button type="danger" color="#489bee" style="padding:0 10px;"
								size="mini">发票信息</van-button>
							<van-button type="danger" v-if="item.status == 1" color="#61ce89" style="padding:0 10px;"
								size="mini">取消申请</van-button>
						</template>

					</van-card>
				</div>
			</van-col>
		</van-row>
	</div>
</template>
<script>
	import Global from '../Global/global.vue';
	import {
		areaList
	} from '@vant/area-data';
	export default {
		data() {
			return {
				invoicesList: [
					{
						id: '1000011',
						number: '1010102992929292211',
						title: '北京易捷智达科技有限公司',
						email: 'aaabc@abc.com',
						status: 0
					},
					{
						id: '1000012',
						number: '1010102992929292212',
						title: '北京易捷智达科技有限公司',
						email: '1aaabc@abc.com',
						status: 1
					}
				],
				fpxxEndTime:'2025-02-02'
			};
			
		},
		created() {

		},
		methods: {

		},
		mounted() {

		}
	};
</script>

<style scoped="scoped">
	.bmForm {
		padding: 20px 0;
	}

	.bmTitle {
		padding: 0px 20px 10px;
		line-height: 40px;
		background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
		background-size: 100% 100%;
		color: #fff;
		text-align: center;
	}

	.bmTitle h2 {
		font-weight: normal;
		font-size: 30px;
	}

	.formInput {
		padding: 4px 0;
		margin: 0 20px;
		border-bottom: 1px solid #e8e8e8;
	}

	.lineddd {
		height: 3px;
		background-color: #e8e8e8;
		margin-top: -1px;
	}

	.van-cell,
	.van-button {
		font-size: 16px;
	}

	.van-cell::after {
		border-bottom: 0;
	}

	.chmContent {
		position: relative;
		padding: 5px;
		width: 210px;
		margin: 20px auto 0;
	}

	.chmContent .chmewm {
		position: relative;
		padding: 4px;
		background: #fff;
		width: 202px;
	}

	.product-hover {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		-webkit-transition: opacity 0.3s ease;
		-moz-transition: opacity 0.3s ease;
		transition: opacity 0.3s ease;
		background-size: 30px 30px;
		background-image: -webkit-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: -moz-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		-webkit-animation: barberpole 0.5s linear infinite;
		-moz-animation: barberpole 0.5s linear infinite;
		animation: barberpole 0.5s linear infinite;
	}

	@-webkit-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@-moz-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	.hide {
		display: none;
	}
	.beizhu{
		line-height: 30px;
		text-align: center;
		padding:20px 0 0;
		color:#ee0a24;
		font-size: 14px;
	}
	.beizhu p{
		margin:0
	}
</style>


// WEBPACK FOOTER //
// src/components/Personal/invoicesmanagement.vue